import React from 'react'
import Heading from '../components/Heading'
import ServiceRow from '../components/ServiceRow'

const ManageServices = (props) => {
    return (
        <div className='add-new-services module'>
            <Heading title='Manage my value-added services' />
            <div className='module-inner'>
                <ServiceRow
                    icon='/images/icon-bell.svg'
                    title='Important message'
                    subTitle='About managing VAS'
                    noUrl
                    closable
                    closableKey='message-re-managing-vas'
                >
                    <div className='h-100 d-flex align-items-center'>
                        Value-added services are temporarily managed in a previous version of My Exetel. Clicking the links below will take you where you need to go. Managing value-added services will be migrated to this version of My Exetel very soon.
                    </div>
                </ServiceRow>
                <ServiceRow
                    icon='/images/icon-email.svg'
                    title='Email @exemail'
                    subTitle='My free email service'
                    url='https://www.exetel.com.au/myexetel/email/view_email'
                >
                    <div className='h-100 d-flex align-items-center'>
                        Setup and manage your exemail account here. Your broadband service comes with 30 free email addresses.
                    </div>
                </ServiceRow>
                <ServiceRow
                    icon='/images/icon-sms.svg'
                    title='SMS via internet'
                    ubTitle='Send bulk SMS'
                    url='https://www.exetel.com.au/myexetel/sms/view_sms_over_web'
                >
                    <div className='h-100 d-flex align-items-center'>
                        You can set up and manage your bulk SMS service here. Note that charges apply when using your SMS via internet service.
                    </div>
                </ServiceRow>
            </div>
        </div>
    )
}

export default ManageServices



// WEBPACK FOOTER //
// ./resources/js/modules/ManageServices.js